import { resetAuthState } from "@funded-here-interface/common/src/features/auth/authSlice_Admin";
import { RefreshCooldownError } from "@funded-here-interface/common/src/hooks/useRefreshAuth";
import { SessionInvalidatedError } from "@funded-here-interface/common/src/Utils/axiosSessionInterceptor";
import { createUnauthorizedRedirectHandler } from "@funded-here-interface/common/src/Utils/unauthorizedRedirect";
import { QueryClient } from "react-query";

import { store } from "../store";

// The global "raw Axios 401 → logout" interceptor is NOT registered here.
// src/index.tsx registers it at app entry via setupUnauthorizedInterceptor
// (with this same handler) so this module stays side-effect-free — see
// axiosUnauthorizedInterceptor.ts for the ordering constraint vs the
// session-kill interceptor.
const handleUnauthorizedRedirect = createUnauthorizedRedirectHandler(store, resetAuthState);

const handleOnError = (message: string) => {
  if (message === "Unauthorized") {
    handleUnauthorizedRedirect();
    return;
  }
};

const client = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (e) => {
        if (e instanceof SessionInvalidatedError) return;
        if (e instanceof RefreshCooldownError) return;
        handleOnError((e as Error).message);
      },
    },
    queries: {
      onError: (e) => {
        if (e instanceof SessionInvalidatedError) return;
        if (e instanceof RefreshCooldownError) return;
        handleOnError((e as Error).message);
      },
    },
  },
});

export { client, handleUnauthorizedRedirect };
